import "./SendInvitation.css";
import { Button } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DownloadIcon from "@mui/icons-material/Download";
import { useEffect, useRef, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const SendInvitation = ({ pediatricianId }) => {
  const [copied, setCopied] = useState(false);
  const [loasing, setloasing] = useState(false);
  const qrRef = useRef(null);
  const token = localStorage.getItem("s2stoken");
  const navigate = useNavigate();
  const link = `https://smile2stepsapp.onrender.com/parent-add-child/${pediatricianId}`;
  // const link = `http://localhost:3000/parent-add-child/${pediatricianId}`
  const [patientLists, setPatientList] = useState([]);
  const handleCopy = () => {
    navigator.clipboard.writeText(link);
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };
  const handleDownload = () => {
    const qrCanvas = document.querySelector("canvas");
    if (!qrCanvas) return;

    const padding = 10;
    const canvasSize = qrCanvas.width + padding * 2;

    const canvas = document.createElement("canvas");
    canvas.width = canvasSize;
    canvas.height = canvasSize;
    const ctx = canvas.getContext("2d");

    // Fill background with white color
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Calculate center position for proper padding
    const x = (canvas.width - qrCanvas.width) / 2;
    const y = (canvas.height - qrCanvas.height) / 2;

    // Draw the QR code in the center
    ctx.drawImage(qrCanvas, x, y);

    // Convert to image and download
    const url = canvas.toDataURL("image/png");
    const a = document.createElement("a");
    a.href = url;
    a.download = "qrcode.png";
    a.click();
  };
  const handleUpdatePatientProfileChange = (patientId) => {
    navigate(`/update-patient/${patientId}/${pediatricianId}`,{state:{updateFromInvitation:true}});
  };

  useEffect(() => {
    const fetchNewPatients = async () => {
      setloasing(true);
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/get_patients_by_parent/${pediatricianId}`,
          {
            withCredentials: true,
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const result = res?.data?.data;
        console.log(result);
        setPatientList(result);
        setloasing(false);
      } catch (error) {
        if (error?.response?.data?.message === "Token has expired") {
          localStorage.removeItem("s2stoken");
          navigate("/");
        }
        console.error("Error fetching patients:", error);
        setloasing(false);
      }
    };

    if (pediatricianId) {
      fetchNewPatients();
    }
  }, [pediatricianId]);
  console.log(patientLists);
  return (
    <div className="invitation-wrapper">
      <div className="invitation-header">
        <h2 className="invitation-heading">
          Invite New Patients
        </h2>
        <div className="animation">
          <p>Your Id: {pediatricianId}</p>
        </div>
      </div>
      <div className="invitation-form">
        <p className="subHeading">
          For remote patients, share this link with the parent
        </p>
        <div className="invitation-link-container">
          <div className="invitation-link">
            <span>{link}</span>
          </div>
          <Button
            variant="contained"
            sx={{ width: { xs: "100px", sm: "120px" } }}
            onClick={handleCopy}
            startIcon={<ContentCopyIcon />}
          >
            {copied ? "Copied" : "Copy"}
          </Button>
        </div>
        <p className="subHeading">OR</p>
        <p className="subHeading">For In-clinic patients, display QR code</p>
        <div className="invitation-qr-container">
          <div ref={qrRef} style={{ marginBottom: "16px" }}>
            <QRCodeCanvas value={link} size={100} />
          </div>
          <Button
            variant="contained"
            sx={{ width: "160px" }}
            onClick={handleDownload}
            startIcon={<DownloadIcon />}
          >
            Download QR
          </Button>
        </div>
      </div>
      <hr
        style={{
          height: "1px",
          color: "black",
          width: "100%",
          margin: "20px 0 10px",
        }}
      />
      <div style={{ width: "100%", textAlign: "left" }}>
        <ul style={{paddingLeft: "20px"}}>
          <li className="bullet-list">
            After the parent submits the questionnaire the new patient will
            appear below.
          </li>
          <li className="bullet-list"> Update details during the first consultation. </li>
          <li className="bullet-list">For future visits, access the patient from your dashboard.</li>
        </ul>
      </div>
      <hr
        style={{
          height: "1px",
          color: "black",
          width: "100%",
          margin: "10px 0 20px",
        }}
      />
      <h3>New Patients List</h3>
      <div className="patient-list-container">
        <div className="patient-list-heading">
          <p>First name</p>
          <p>Last name</p>
          <p>DOB</p>
          <p>Action</p>
        </div>
        {loasing ? (
          <p>Loading...</p>
        ) : patientLists.length > 0 ? (
          patientLists.map((data, i) => (
            <div key={i} className="patient-list-data">
              <p translate="no">{data.first_name}</p>
              <p translate="no">{data.last_name}</p>
              <p>{data.date_of_birth.split(",")[1].slice(0, 12)}</p>
              <button
                onClick={() =>
                  handleUpdatePatientProfileChange(data.patient_id)
                }
              >
                Update
              </button>
            </div>
          ))
        ) : (
          "New patient List is empty"
        )}
      </div>
    </div>
  );
};
export default SendInvitation;
